import PrizeTrophyIcon from '../../assets/icons/resources-guide-prize-trophy.svg?react';
import TennisIcon from '../../assets/icons/resources-guide-tennis.svg?react';
import InfoIcon from '../../assets/icons/resources-guide-info.svg?react';
import BotIcon from '../../assets/icons/resources-guide-bot.svg?react';
import { cn } from '@/utils';
import type { ResourceGuideIcon } from '../../constants/resources-guide.constants';

const RESOURCE_GUIDE_ICONS = {
	info: InfoIcon,
	scoring: TennisIcon,
	prize: PrizeTrophyIcon,
	bot: BotIcon,
} as const;

const RESOURCE_GUIDE_ICON_SIZES: Record<ResourceGuideIcon, string> = {
	prize: 'size-6',
	scoring: 'size-[22px]',
	info: 'size-6',
	bot: 'h-4 w-5',
};

export function ResourceGuideIconBadge({
	icon,
	iconClassName,
	imageUrl,
}: {
	icon: ResourceGuideIcon;
	iconClassName: string;
	/** Custom uploaded icon URL from admin Resources config; takes priority over `icon`. */
	imageUrl?: string | null;
}) {
	const Icon = RESOURCE_GUIDE_ICONS[icon];

	return (
		<div
			className={cn(
				'flex size-10 shrink-0 items-center justify-center overflow-hidden rounded-full border-[0.5px] p-2',
				iconClassName
			)}
		>
			{imageUrl ? (
				<img src={imageUrl} alt="" className="size-full object-contain" />
			) : (
				<Icon className={cn('shrink-0', RESOURCE_GUIDE_ICON_SIZES[icon])} aria-hidden="true" />
			)}
		</div>
	);
}
